import History from './history'

export default {
	namespaced: true,
	modules:{
		history: History
	}
};
